declare namespace $ {

	export class $mol_icon_checkbox_marked extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=marked.view.tree.d.ts.map